import VideoEmbed from './VideoEmbed.vue'

export default VideoEmbed
